export { default, getServerSideProps } from '@/views/Auth/pages/B2BOrgRecover';
